import React, { useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import ImageOne from "../../assets/QuoteIcons/image1.png";
import ImageTwo from "../../assets/QuoteIcons/image2.png";
import ImageThree from "../../assets/QuoteIcons/image3.png";
import Logo from "../../assets/QuoteIcons/image4.png";
import QRCode from "../../assets/qr-code.png";
import MobileImageOne from "../../assets/image8.png";
import MobileImageTwo from "../../assets/image9.png";
import Appstore from "../../assets/Appstore.png";
import Playstore from "../../assets/Playstore.png";
import CloseIcon from "@mui/icons-material/Close";

const QuoteData = [
  {
    image: ImageOne, // Directly pass the imported path
    carrier: "UPS",
    service: "World Saver",
    fromCountry: "India",
    dimensionL: "8",
    dimensionH: "12",
    dimensionW: "12",
    weight: "2.5",
    deliveryTime: "2-6",
    price: "289.99",
  },
  {
    image: ImageTwo, // Directly pass the imported path
    carrier: "FedEx",
    service: "International Connect",
    fromCountry: "India",
    dimensionL: "8",
    dimensionH: "12",
    dimensionW: "12",
    weight: "2.5kg",
    deliveryTime: "2-6",
    price: "289.99",
  },
  {
    image: ImageThree, // Directly pass the imported path
    carrier: "DHL",
    service: "Express",
    fromCountry: "India",
    dimensionL: "8",
    dimensionH: "12",
    dimensionW: "12",
    weight: "2.5",
    deliveryTime: "2-6",
    price: "289.99",
  },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  borderRadius: "10px",
  // boxShadow: 24,
  px: 2,
};

function QuoteList({ setGetShippingQuotes,setShowQuote, getShippingQuotes,formValues }) {
  const [ToggalOpen, setToggleOpen] = React.useState(false);
  const handleOpen = () => setToggleOpen(true);
  const handleClose = () => setToggleOpen(false);
  console.log(getShippingQuotes,"getShippingQuotes");

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "95%",
          margin: "24px 10px 0 10px",
        }}
      >
        <Typography>{`${getShippingQuotes?.length} items found`}</Typography>
        <Button onClick={() => {setGetShippingQuotes([]);setShowQuote(false)}}>
          Get a new quote
        </Button>
      </Box>
      <Grid container spacing={0} justifyContent="center">
        {getShippingQuotes&&getShippingQuotes?.map((option, index) => (
          <Grid item xs={12} md={12} key={index}>
            <Box
              sx={{ 
                marginTop: "25px",
                border: "1px solid #E5E5E8",
                borderRadius: "20px",
                width: "95%",
                // maxWidth: "800px",
                // width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "13px 30px",
                  borderBottom: "1px solid #E5E5E8",
                  flexWrap: "wrap"
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontWeight: "600",
                    fontSize: "15px",
                    color: "#1C2630",
                    marginY: 1
                  }}
                >
                  <img
                    src={option.courier_service?.logo}
                    alt={""}
                    style={{
                      width: "50px",
                      height: "auto",
                      objectFit: "contain",
                      marginRight: "10px",
                      marginBottom: 1
                    }}
                  />
                  {option.courier_service?.name}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "10px",
                    flexWrap: "wrap"
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "700",
                      fontSize: "20px",
                      color: "#1C2630",
                    }}
                  >
                    ${(option.shipment_charge_total + (option.shipment_charge_total* (option.markup/100))).toFixed(2)}
                  </Typography>
                  <Button
                    variant="outlined"
                    sx={{
                      border: "1px solid #481AA3",
                      width: "122px",
                      fontWeight: "600",
                      fontSize: "16px",
                      color: "#481AA3",
                    }}
                    onClick={handleOpen}
                  >
                    Ship Now
                  </Button>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "25px",
                  flexWrap: "wrap",
                  paddingBottom: "0px"
                }}
              >
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    rowGap: "14px",
                    marginBottom: 3
                  }}
                >
                  <span
                    style={{
                      fontWeight: "500",
                      fontSize: "17px",
                      color: "#959BA1",
                    }}
                  >
                    From Country
                  </span>
                  <span
                    style={{
                      fontWeight: "700",
                      fontSize: "22px",
                      color: "#1C2630",
                    }}
                  >
                    {formValues.originCountry}
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    rowGap: "14px",
                    marginBottom: 3
                  }}
                >
                  <span
                    style={{
                      fontWeight: "500",
                      fontSize: "17px",
                      color: "#959BA1",
                    }}
                  >
                    Dimensions
                  </span>
                  <span
                    style={{
                      fontWeight: "700",
                      fontSize: "22px",
                      color: "#1C2630",
                    }}
                  >
                    {formValues.length} * {formValues.width} *{" "}
                    {formValues.height}
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    rowGap: "14px",
                    marginBottom: 3
                  }}
                >
                  <span
                    style={{
                      fontWeight: "500",
                      fontSize: "17px",
                      color: "#959BA1",
                    }}
                  >
                    Weight
                  </span>
                  <span
                    style={{
                      fontWeight: "700",
                      fontSize: "22px",
                      color: "#1C2630",
                    }}
                  >
                    {formValues.weight}kg
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    rowGap: "14px",
                    marginBottom: 3
                  }}
                >
                  <span
                    style={{
                      fontWeight: "500",
                      fontSize: "17px",
                      color: "#959BA1",
                    }}
                  >
                    Delivery time
                  </span>
                  <span
                    style={{
                      fontWeight: "700",
                      fontSize: "22px",
                      color: "#1C2630",
                    }}
                  >
                    {option.min_delivery_time} Business days
                  </span>
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Modal open={ToggalOpen} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxWidth: "800px",
            backgroundColor: "#ffffff",
            borderRadius: "20px",
            boxShadow: 24,
            p: 4,
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              borderBottom: "1px solid #E5E5E8",
              pb: 1,
              position: "relative", // Ensure positioning for absolute elements
            }}
          >
            {/* Centered Text with Logo */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%", // Ensures it spans full width
                position: "relative", // To stay within the parent box
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "#481AA3",
                  textAlign: "center",
                }}
              >
                {/* Logo */}
                <img
                  src={Logo}
                  alt="POSTPAL Logo"
                  style={{
                    width: "24px",
                    height: "24px",
                    objectFit: "contain",
                  }}
                />
                POSTPAL
              </Box>
            </Box>

            {/* Close Button */}
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Main Content */}
          <Box
            sx={{
              textAlign: "center",
            }}
          >
            <Typography
              variant="h5"
              sx={{ fontWeight: "700", mb: 2, color: "#1C2630" }}
            >
              Download POSTPAL
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#5A5A5A",
                fontSize: "14px",
                mb: 4,
              }}
            >
              We've designed a seamless mobile experience to provide full
              tracking from your purchase or shipping request to final delivery.
              Stay updated every step of the way—download PostPal now!
            </Typography>
          </Box>

          {/* QR Code and App Links */}
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
              <div className="flex">
                <img
                  src={QRCode}
                  alt="QR Code"
                  style={{ width: "40%", height: "40%" }}
                />
                <div className="ps-2">
                  <img
                    src={Appstore}
                    alt="Appstore"
                    style={{ width: "60%", height: "40%",margin:"5px" }}
                    onClick={()=>{window.open('http://Appstore.postpal.me/ios','_blank')}}
                  />
                  <img
                    src={Playstore}
                    alt="Playstore"
                    style={{ width: "60%", height: "40%",margin:"5px" }}
                    onClick={()=>{window.open("http://playstore.postpal.me/android",'_blank')}}
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <img
                  src={MobileImageTwo}
                  alt="Get it on Google Play"
                  style={{ width: "150px" }}
                />
                <img
                  src={MobileImageOne}
                  alt="Download on the App Store"
                  style={{ width: "150px", marginBottom: "10px" }}
                />
              </Box>
            </Grid>
            {/* <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
              <img
                src={Logo}
                alt="App Preview"
                style={{ maxWidth: "100%", borderRadius: "10px" }}
              />
            </Grid> */}
          </Grid>
        </Box>
      </Modal>
    </>
  );
}

export default QuoteList;
